import React from 'react';

import {DateTime} from 'luxon';
import Helmet from 'react-helmet';

import Link from 'gatsby-link';

import {TagListFromStrings} from '../components/TagList';

import ucfirst from '../ucfirst';

export default function Template({
	data, // From GraphQL
}) {
	const {
		markdownRemark,
	} = data;
	const {
		frontmatter,
		html,
	} = markdownRemark;

	const date = DateTime.fromISO(frontmatter.date);
	let dateString;
	if (/^\d\d\d\d$/.test(frontmatter.date)) {
		dateString = date.toFormat('yyyy');
	} else if (/^\d\d\d\d-\d\d$/.test(frontmatter.date)) {
		dateString = date.toFormat('MMMM yyyy');
	} else {
		dateString = date.toFormat('MMMM d, yyyy');
	}

	const writeupDate = DateTime.fromISO(frontmatter.writeupDate);

	return (
		<React.Fragment>
			<Helmet title={ucfirst(frontmatter.title)} />

			<nav>
				<Link to="/">↩ Home</Link>
			</nav>

			<article>
				<header className="projectHeader">
					<h1>{ucfirst(frontmatter.title)}</h1>

					{frontmatter.summary &&
						<p className="projectSummary">
							{ucfirst(frontmatter.summary)}
						</p>
					}

					{frontmatter.taskSummary &&
						<p className="taskSummary">
							{ucfirst(frontmatter.taskSummary)}
						</p>
					}

					<TagListFromStrings tags={frontmatter.tags} />

					<p className="projectDate">
						<time dateTime={frontmatter.date}>{dateString}</time>
					</p>

					{frontmatter.url &&
						<p className="projectUrl">
							<a href={frontmatter.url} aria-label="Visit the live website">
								{frontmatter.url}
							</a>
						</p>
					}
				</header>

				<div dangerouslySetInnerHTML={{__html: html}} />

				<footer className="projectFooter">
					<time dateTime={writeupDate.toFormat('yyyy-MM-dd')}>
						{writeupDate.toFormat('MMMM d, yyyy')}
					</time>
				</footer>
			</article>
		</React.Fragment>
	);
}

export const pageQuery = graphql`
	query ProjectByPath($path: String!) {
		markdownRemark(
			frontmatter: {
				path: {
					eq: $path,
				},
			},
		) {
			frontmatter {
				date
				path
				summary
				tags
				taskSummary
				title
				url
				writeupDate
			}
			html
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/project.js